import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Dialog, DialogFooter} from '@taopix/taopix-design-system';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../../Context/UserInterface/UserInterfaceActionTypes';
import {DialogStatus} from '../../../Enums';
import {Common, PageConstants, ViewMode} from '@taopix/taopix-core';
import useViewMode from '../../../Hooks/useViewMode';
import {useTaopix} from '../../Context/TaopixContext';

type CoverSpineWidthChangeNotificationProps = {
  open: boolean;
};

const SpineWidthChangeNotification = ({open}: CoverSpineWidthChangeNotificationProps) => {
  const {t} = useTranslation(['*', 'dialogs']);
  const ui = useUiState();
  const [viewMode] = useViewMode();
  const app = useTaopix();

  const btnLabel = useMemo(() => {
    return Common.isFrontCover(ui.state.pageNumber) || ViewMode.Grid === viewMode
      ? t('str_ButtonClose')
      : t('str_ButtonGoToCover');
  }, [ui.state.pageNumber, viewMode]);

  const onGoToCover = () => {
    ui.dispatch(
      UserInterfaceActions.setDialogStatus({coverSpineChangeNotification: DialogStatus.Seen})
    );

    if (Common.isFrontCover(ui.state.pageNumber) || viewMode === ViewMode.Grid) {
      // User is already on the front cover so count it as seen.
      ui.dispatch(UserInterfaceActions.setFlags({coverNeedsChecking: false}));
    } else {
      app.core
        .get('abilities')
        .setPage(PageConstants.FrontCoverPageNumber)
        .then(() => {
          ui.dispatch(UserInterfaceActions.setFlags({coverNeedsChecking: false}));
        });
    }
  };

  return (
    <Dialog
      open={open}
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      width={400}
      title={t('dialogs:str_TitleCoverSpineWidthChange', {
        defaultValue: 'Cover Spine Width Changed',
      })}
      showTitle={false}
      aria-live="assertive"
    >
      <div className={'p-md'}>
        <p>{t('*:str_MessageMainCoverResized')}</p>
      </div>
      <DialogFooter>
        <Button label={btnLabel} buttonStyle={'primary'} onClick={onGoToCover} />
      </DialogFooter>
    </Dialog>
  );
};

export default SpineWidthChangeNotification;
